export default __webpack_public_path__ + "static/media/CheckIcon.aafac3c2.svg";